import { connect } from "react-redux";
import Overview from "./Overview";

const mapStateToProps = (state, ownProps) => {
  return {
    filterPanelVisible: state.ui.overviewFiltersVisible && !state.ui.focused,
    tabLabel: ownProps.labels[ownProps.tabIndex]
  };
};

const OverviewContainer = connect(mapStateToProps)(Overview);

export default OverviewContainer;



// WEBPACK FOOTER //
// ./src/OverviewContainer.js